// Mock data for Kibouor Foundation website

export const heroContent = {
  tagline: "Where Hope Finds a Home.",
  subtitle: "Where generations heal together.",
  description: "A home that gives back the meaning of family.",
  heroImage: "https://images.unsplash.com/photo-1605888357467-9caf88c89f67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMGVsZGVybHklMjB0b2dldGhlcnxlbnwwfHx8fDE3NjA1NDUyODB8MA&ixlib=rb-4.1.0&q=85"
};

export const aboutContent = {
  title: "✦ About Kibouor",
  quote: "We don't build shelters. We build families.",
  description: "Kibouor is a co-habitation initiative where orphans and abandoned elderly live together — rebuilding hope, purpose, and belonging. We believe healing happens when generations unite — when the wisdom of age meets the innocence of youth.",
  mission: "To create loving homes where orphaned children and abandoned elderly find family, dignity, and purpose through shared living.",
  vision: "A world where no child grows up without love — and no elder fades away forgotten.",
  story: "A movement born from compassion, powered by AR Holdings Group's vision for humanity. Kibouor stands as proof that business and empathy can coexist — that technology, transparency, and love can build something truly timeless. Each home is a living ecosystem, sustained by both public donations and funding from AR Holdings' diverse companies, ensuring every dollar is used for real impact — not profit.",
  image: "https://images.pexels.com/photos/6973191/pexels-photo-6973191.jpeg"
};

export const homesData = [
  {
    id: 1,
    name: "Kibouor Home – Jakarta",
    location: "Manila, Philippines",
    capacity: "👧 8 children · 👵 12 elderly",
    status: "Active",
    image: "https://images.pexels.com/photos/6158679/pexels-photo-6158679.jpeg",
    description: "Our flagship home where three generations live, learn, and love together."
  },
  {
    id: 2,
    name: "Kibouor Home – Cebu",
    location: "Cebu, Philippines",
    capacity: "👧 5 children · 👵 15 elderly",
    status: "Active",
    image: "https://images.unsplash.com/photo-1507427100689-2bf8574e32d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxodW1hbml0YXJpYW58ZW58MHx8fHwxNzYwNTQ1Mjk1fDA&ixlib=rb-4.1.0&q=85",
    description: "A coastal sanctuary where ocean breezes carry laughter and stories."
  },
  {
    id: 3,
    name: "Kibouor Home – Chiang Mai (Under Construction)",
    location: "Chiang Mai, Thailand",
    capacity: "Opening 2026",
    status: "Under Construction",
    image: "https://images.unsplash.com/photo-1727475805926-b731fa90dee3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxodW1hbml0YXJpYW58ZW58MHx8fHwxNzYwNTQ1Mjk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Opening 2026 — expanding hope to more hearts."
  }
];

export const storiesData = [
  {
    id: 1,
    name: "Maria",
    age: 9,
    story: "Lost her parents in a flood. Today, she calls Mrs. Lopez 'Grandma.'",
    quote: "Grandma says I remind her of sunshine. She makes me feel safe.",
    image: "https://images.unsplash.com/photo-1545603343-8356d34ed7bb"
  },
  {
    id: 2,
    name: "Mr. Santos",
    age: 78,
    story: "Abandoned by his family, he found purpose again teaching chess to young boys.",
    quote: "These children gave me a reason to wake up. I'm needed again.",
    image: "https://images.pexels.com/photos/6972784/pexels-photo-6972784.jpeg"
  },
  {
    id: 3,
    name: "Ana & Mrs. Cruz",
    age: "7 & 82",
    story: "They water the garden together every morning.",
    quote: "We take care of each other. That's what families do.",
    image: "https://images.unsplash.com/photo-1683624328172-88fb24625ec1"
  },
  {
    id: 4,
    name: "Carlos",
    age: 11,
    story: "Once shy to read aloud — now reads bedtime stories to elders.",
    quote: "They listen to me like my words matter. Because they do.",
    image: "https://images.unsplash.com/photo-1504151932400-72d4384f04b3"
  }
];

export const impactData = {
  totalDonations: 350743,
  childrenSupported: 13,
  elderlySupported: 39,
  mealsServed: 50000,
  volunteersEngaged: 53,
  beneficiariesSupported: 52,
  sustainableVillagesBuilt: 3,
  allocation: [
    { category: "🍽 Nutrition", percentage: 40, amount: 150000 },
    { category: "🏠 Housing", percentage: 30, amount: 150000 },
    { category: "❤️ Healthcare", percentage: 20, amount: 100000 },
    { category: "📚 Education", percentage: 10, amount: 100000 }
  ],
  recentTransactions: [
    { id: "0x7d8f...a3c2", amount: 5000, date: "2025-08-10", verified: true },
    { id: "0x9b2e...f7d1", amount: 10000, date: "2025-08-09", verified: true },
    { id: "0x3a1c...b8e4", amount: 2500, date: "2025-08-08", verified: true },
    { id: "0x4f9b...e8c5", amount: 1200, date: "2025-08-07", verified: true },
    { id: "0x1a8c...b5e9", amount: 1000, date: "2025-08-07", verified: true },
    { id: "0x6d2a...a4b1", amount: 800, date: "2025-08-06", verified: true },
    { id: "0x8b3f...d9f4", amount: 700, date: "2025-08-06", verified: true },
    { id: "0x5c4a...e2d3", amount: 600, date: "2025-08-06", verified: true },
    { id: "0x9f7a...b3c1", amount: 500, date: "2025-08-05", verified: true },
    { id: "0x3e9b...d4a2", amount: 450, date: "2025-08-05", verified: true },
    { id: "0x8a1c...e8f3", amount: 400, date: "2025-08-05", verified: true },
    { id: "0x2b4e...c7d2", amount: 350, date: "2025-08-04", verified: true },
    { id: "0x6d9f...a2e8", amount: 300, date: "2025-08-04", verified: true },
    { id: "0x9e7c...f1b9", amount: 250, date: "2025-08-03", verified: true },
    { id: "0x3a4b...e9c8", amount: 240, date: "2025-08-03", verified: true },
    { id: "0x4d8f...b7a1", amount: 230, date: "2025-08-03", verified: true },
    { id: "0x7e5a...f2d6", amount: 220, date: "2025-08-03", verified: true },
    { id: "0x1b9c...e4a3", amount: 210, date: "2025-08-02", verified: true },
    { id: "0x8d4a...b2c7", amount: 200, date: "2025-08-02", verified: true },
    { id: "0x5e7b...d1f8", amount: 180, date: "2025-08-02", verified: true },
    { id: "0x9f1a...c6b3", amount: 170, date: "2025-08-02", verified: true },
    { id: "0x3b8e...a5d9", amount: 160, date: "2025-08-01", verified: true },
    { id: "0x6a9c...f4e7", amount: 150, date: "2025-08-01", verified: true },
    { id: "0x7f8a...b2d5", amount: 140, date: "2025-08-01", verified: true },
    { id: "0x9e2c...d7a3", amount: 130, date: "2025-08-01", verified: true },
    { id: "0x2b7d...a3f9", amount: 120, date: "2025-07-31", verified: true },
    { id: "0x4f1e...b8c6", amount: 110, date: "2025-07-31", verified: true },
    { id: "0x8a5c...d2f1", amount: 100, date: "2025-07-31", verified: true },
    { id: "0x3b7e...f1a8", amount: 90, date: "2025-07-31", verified: true },
    { id: "0x9d3a...c5b4", amount: 80, date: "2025-07-31", verified: true }
  ]
};

export const donationTiers = [
  {
    id: 1,
    name: "$50 — Nourish a Soul",
    amount: 50,
    description: "Provides meals for one person for a week",
    impact: "Weekly nutrition support"
  },
  {
    id: 2,
    name: "$200 — Sponsor a Room",
    amount: 200,
    description: "Maintains a living space for one month",
    impact: "Monthly housing support",
    popular: true
  },
  {
    id: 3,
    name: "$1,000 — Sponsor a Home",
    amount: 1000,
    description: "Full operational support for a Kibouor home",
    impact: "Complete home support"
  },
  {
    id: 4,
    name: "Custom Amount",
    amount: "custom",
    description: "Every contribution creates ripples of hope",
    impact: "Flexible support"
  }
];

export const footerLinks = {
  about: [
    { label: "Our Story", href: "#about" },
    { label: "Our Homes", href: "#homes" },
    { label: "Impact & Transparency", href: "#impact" },
    { label: "AR Holdings Group", href: "https://arholdings.group" }
  ],
  getInvolved: [
    { label: "Donate Now", href: "#donate" },
    { label: "Volunteer", href: "#volunteer" },
    { label: "Corporate Partnership", href: "#partner" },
    { label: "Stories of Hope", href: "#stories" }
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Foundation Registration", href: "/registration" },
    { label: "Blockchain Proof", href: "/blockchain" }
  ],
  social: [
    { platform: "Facebook", url: "https://facebook.com/kibouor" },
    { platform: "Instagram", url: "https://instagram.com/kibouor" },
    { platform: "Twitter", url: "https://twitter.com/kibouor" },
    { platform: "LinkedIn", url: "https://linkedin.com/company/kibouor" }
  ]
};

export const contactInfo = {
  email: "hello@kibouor.org",
  phone: "+1 650 338 8168",
  address: "AR Holdings Building, Mountain View, CA",
  website: "www.kibouor.org",
  blockchainVerified: "Dot Protocol (https://thedotprotocol.com)",
  registrationNumber: "UEN: 202514625N",
  foundationName: "Kibouor Foundation (SG)",
  registeredCharity: "Registered Charity under Singapore Charities Act (Cap. 37)",
  chainId: "Chain ID 1546"
};